import * as React from "react"
import type { SVGProps } from "react"
const SvgSlash = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11.41 18.05a1 1 0 0 1-.46.62 1 1 0 0 1-.76.1 1 1 0 0 1-.62-.47 1 1 0 0 1-.09-.76l3.1-11.6a1 1 0 0 1 .47-.6 1 1 0 0 1 .76-.1q.41.11.62.46.2.36.09.76z" />
  </svg>
)
export default SvgSlash
